import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import adicionarFiltroItinerario from '../../actions/itinerario/adicionarFiltroItinerario'
import removerFiltroItinerario from '../../actions/itinerario/removerFiltroItinerario'
import listarFiltrosItinerario from '../../actions/itinerario/listarFiltrosItinerario'
import { alterouEmpresa } from '../../actions/empresa/alterarEmpresaSelecionada';
import FiltroBuscarItinerario from './FiltroBuscarItinerario';
import FiltroChaveValor from '../comum/FiltroChaveValor';
import FiltroIdsItinerarios from './FiltroIdsItinerarios';
import {
  FILTRO_DATA_PARTIDA,
  FILTRO_VENDAS_ITINERARIO,
  FILTRO_STATUS_ITINERARIO,
  FILTRO_HORARIO_EXTRA,
  FILTRO_TIPO_CATEGORIA,
  FILTRO_VEICULO,
  FILTRO_MOTORISTA,
  FILTRO_TIPO_CONFIGURACAO_PRECO,
  FILTRO_TIPO_AJUSTE,
  FILTRO_PORCENTAGEM,
  FILTRO_PRESTADOR,
  FILTRO_TIPO_PRECO
 } from '../../util/filtros'

export class FiltroItinerarios extends Component {
  componentDidMount () {
    if (this.props.empresaSelecionada && this.props.empresaSelecionada.id) {
      this.props.listarFiltrosItinerario(this.props.empresaSelecionada.id)
    }
  }

  componentDidUpdate (prevProps) {
    if (alterouEmpresa(this.props, prevProps)) {
      this.props.listarFiltrosItinerario(this.props.empresaSelecionada.id)
    }
  }


  adicionarFiltro (filtro) {
    this.props.adicionarFiltroItinerario(filtro)
  }

  removerFiltro (filtro) {
    this.props.removerFiltroItinerario(filtro)
  }

  render () {
    return (
      <React.Fragment>
        <div className="conteudo">          
          
          <FiltroBuscarItinerario 
            filtro={FILTRO_DATA_PARTIDA}
            opcoes={[new Date().getFullYear()]}
            isFiltroData={true}
          />
          <FiltroBuscarItinerario 
            filtro={FILTRO_VENDAS_ITINERARIO}
            opcoes={['Com vendas', 'Sem vendas']}
            isRadio={true}
          />
           <FiltroBuscarItinerario
            filtro={FILTRO_STATUS_ITINERARIO}
            opcoes={['Ativo', 'Inativo']}
            isRadio={true}
          />
          <FiltroBuscarItinerario
            filtro={FILTRO_HORARIO_EXTRA}
            opcoes={['Sim', 'Não']}
            isRadio={true}
          />
          <FiltroBuscarItinerario
            filtro={FILTRO_VEICULO}
            opcoes={[]}
            isNome={true}
          />
          <FiltroBuscarItinerario 
            filtro={FILTRO_MOTORISTA}
            opcoes={[]}
            isNome={true}
          />
          <FiltroBuscarItinerario 
            filtro={FILTRO_PRESTADOR}
            opcoes={[]}
            isNome={true}
          />
          <FiltroChaveValor
            filtro={FILTRO_TIPO_AJUSTE}
            opcoes={this.props.tipoAjuste}
            filtrosAdicionados={this.props.filtrosAdicionados}
            adicionarFiltro={this.adicionarFiltro.bind(this)}
            removerFiltro={this.removerFiltro.bind(this)}
          />
          <FiltroBuscarItinerario 
            filtro={FILTRO_PORCENTAGEM}
            opcoes={[]}
            isPorcentagem={true}
          />
          <FiltroChaveValor
            filtro={FILTRO_TIPO_CONFIGURACAO_PRECO}
            opcoes={this.props.tipoConfiguracaoPreco}
            filtrosAdicionados={this.props.filtrosAdicionados}
            adicionarFiltro={this.adicionarFiltro.bind(this)}
            removerFiltro={this.removerFiltro.bind(this)}
          />
          <FiltroChaveValor
            filtro={FILTRO_TIPO_PRECO}
            opcoes={this.props.tipoPrecos}
            filtrosAdicionados={this.props.filtrosAdicionados}
            adicionarFiltro={this.adicionarFiltro.bind(this)}
            removerFiltro={this.removerFiltro.bind(this)}
          />
           <FiltroBuscarItinerario
            filtro={FILTRO_TIPO_CATEGORIA}
            opcoes={['UNICA', 'MISTA']}
            isRadio={true}
          />
          <FiltroIdsItinerarios />
        </div>
      </React.Fragment>
    )
  }
}

export const mapStateToProps = state => ({  
  tipoConfiguracaoPreco: state.filtrosItinerarios.tipoConfiguracaoPreco,
  tipoAjuste: state.filtrosItinerarios.tipoAjuste,
  filtrosAdicionados: state.filtrosAdicionadosItinerario,
  empresaSelecionada: state.empresaSelecionada,
  tipoPrecos: state.filtrosItinerarios.tipoPrecos

})

export const mapDispatchToProps = dispatch => (
  bindActionCreators({
    adicionarFiltroItinerario,
    removerFiltroItinerario,
    listarFiltrosItinerario
  }, dispatch)
)

export default connect(mapStateToProps, mapDispatchToProps)(FiltroItinerarios)
